import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AppRoutes from '@ui/layout/AppRoutes';
import './App.css';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
function App() {
    const location = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        if (location.pathname === '/') {
            navigate('/incident-history');
        }
    }, [location, navigate]);
    return (_jsxs("div", { children: [_jsx(AppRoutes, {}), _jsx(ToastContainer, { position: 'top-right', newestOnTop: true, pauseOnHover: true, theme: 'colored' }), ' '] }));
}
export default App;
